<script>
import CourseList from '@/views/ExtendableBases/CourseList/'

export default {
  extends: CourseList,
  computed: {
    header() {
      let title = `Moje kursy`
      if (this.pagination.total) {
        title = `${title} <sup>(${this.pagination.total})</sup>`
      }
      return {
        title
      }
    }
  },
  methods: {
    getEditRoute(item) {
      return `/kursant/kursy/szczegoly/${item.id}/kalendarz/`
    },
    actions(course) {
      return [
        {
          type: 'router-link',
          to: this.getEditRoute(course),
          text: 'szczegóły'
        }
      ]
    }
  }
}
</script>
